import { DOCUMENT_MODE } from "../../../constants/document";
import DummyCommand from "../dummyCommand";
import DeleteDocComponentCommand from "./deleteDocComponentCommand";
import DeletePDFDocCommand from "./deletePDFDocCommand";
import DeletePDFTemplateCommand from "./deletePDFTemplateCommand";
import DeleteTemplateComponentCommand from "./deleteTemplateComponentCommand";

class DeleteComponentBaseFactory {
  static getDeleteComponentCommandInstance(mode, isPDF, componentData) {
    if (isPDF && mode === DOCUMENT_MODE.DOCUMENT) {
      return new DeletePDFDocCommand(componentData);
    }
    if (isPDF && mode === DOCUMENT_MODE.TEMPLATE) {
      return new DeletePDFTemplateCommand(componentData);
    }
    if (mode === DOCUMENT_MODE.DOCUMENT) {
      return new DeleteDocComponentCommand(componentData);
    }
    if (mode === DOCUMENT_MODE.TEMPLATE) {
      return new DeleteTemplateComponentCommand(componentData);
    }

    return new DummyCommand();
  }
}

export default DeleteComponentBaseFactory;
